import { render, staticRenderFns } from "./Account_verify.vue?vue&type=template&id=21006890&scoped=true"
import script from "./Account_verify.vue?vue&type=script&lang=js"
export * from "./Account_verify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21006890",
  null
  
)

export default component.exports